import * as React from "react";
const SvgInventoryOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M20 2c1 0 2 .9 2 2v3.01c0 .72-.43 1.34-1 1.69V20c0 1.1-1.1 2-2 2H5c-.9 0-2-.9-2-2V8.7c-.57-.35-1-.97-1-1.69V4c0-1.1 1-2 2-2zM5 9v11h14V9zm10 5H9v-2h6zM4 4v3h16V4z"
    />
  </svg>
);
export default SvgInventoryOutlined;
